import { useTranslation } from "@sagot/i18n";
import { Skeleton } from "@sagot/ui";

/** Shown while the guide chunk loads: the title block, the search box, the module column and a few cards. */
export function GuideSkeleton() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-7xl space-y-6" role="status" aria-label={t("guide.loadingLabel")}>
      <div className="space-y-2">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-4 w-80 max-w-full" />
      </div>
      <Skeleton className="h-11 w-full" />
      <div className="flex flex-col gap-6 lg:flex-row lg:items-start">
        <div className="hidden w-64 shrink-0 space-y-1 lg:block">
          {Array.from({ length: 8 }, (_, index) => (
            <Skeleton key={index} className="h-9 w-full" />
          ))}
        </div>
        <div className="grid min-w-0 flex-1 grid-cols-1 gap-3 md:grid-cols-2">
          {Array.from({ length: 6 }, (_, index) => (
            <Skeleton key={index} className="h-28 w-full" />
          ))}
        </div>
      </div>
    </div>
  );
}
